export default __webpack_public_path__ + "static/media/hdb-flat-1.f9f3acf9.svg";